
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import UseCaseFile from '@/components/medical/UseCaseFile';
import { ArrowLeft } from 'lucide-react';

const PostTreatmentReportPage = () => {
  const { patientId } = useParams<{ patientId: string }>();
  const navigate = useNavigate();

  return (
    <div className="container mx-auto p-6">
      <div className="flex items-center mb-6">
        <Button variant="ghost" onClick={() => navigate(-1)} className="mr-4">
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back
        </Button>
        <h1 className="text-2xl font-bold">Post-Treatment Report</h1>
      </div>

      {patientId && <UseCaseFile patientId={patientId} />}

      {/* Post treatment report content would go here */}
      <div className="mt-6 bg-white p-6 rounded-lg shadow">
        <h2 className="text-xl font-semibold mb-4">Report Details</h2>
        <p>This is a placeholder for the post-treatment report details.</p>
      </div>
    </div>
  );
};

export default PostTreatmentReportPage;
